/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCurrencyRufiyaa = createReactComponent("currency-rufiyaa", "IconCurrencyRufiyaa", [
  ["path", { d: "M20 16h.01", key: "svg-0" }],
  ["path", { d: "M4 16c9.5 -4 11.5 -8 14 -9", key: "svg-1" }],
  ["path", { d: "M12 8l5 3", key: "svg-2" }]
]);

export { IconCurrencyRufiyaa as default };
//# sourceMappingURL=IconCurrencyRufiyaa.js.map
